import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <Box 
      sx={{ 
        py: 4, 
        backgroundColor: '#333',
        color: 'white',
        mt: 'auto'  // This helps push the footer to the bottom
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="body2" sx={{ textAlign: { xs: 'center', md: 'left' } }}>
              © {new Date().getFullYear()} Check4DNR. All rights reserved.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box 
              sx={{ 
                display: 'flex', 
                justifyContent: { xs: 'center', md: 'flex-end' },
                gap: 3
              }}
            >
              <Link to="/about" style={{ color: 'white', textDecoration: 'none' }}>
                <Typography variant="body2" sx={{ '&:hover': { textDecoration: 'underline' } }}>
                  About
                </Typography>
              </Link>
              <Link to="/terms" style={{ color: 'white', textDecoration: 'none' }}>
                <Typography variant="body2" sx={{ '&:hover': { textDecoration: 'underline' } }}>
                  Terms of Service
                </Typography>
              </Link>
              <Link to="/privacy" style={{ color: 'white', textDecoration: 'none' }}>
                <Typography variant="body2" sx={{ '&:hover': { textDecoration: 'underline' } }}>
                  Privacy Policy
                </Typography>
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Footer;